// extracted by mini-css-extract-plugin
module.exports = {"copyIcon":"copy-button_copyIcon__ewgb5","tooltip":"copy-button_tooltip__g5mbt","visible":"copy-button_visible__o9z4D","tooltipArrow":"copy-button_tooltipArrow__fU5sS"};